import LeafletMap from "./Leaflet";
import GoogleMap from "./GoogleMap";

const Map = LeafletMap;

export { LeafletMap, GoogleMap, Map };
